import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import { useEffect, useState } from "react";
import { DownloadFormat } from "~/components/organisation/reporting/apiOrganisationSoftwareQuality";
import { useSoftwareQualityOverviewContext } from "~/components/organisation/reporting/SoftwareQualityOverviewContext";
import { QualityReportDownloadHistory } from "./QualityReportDownloadHistory";
import Grid from "@mui/material/Grid";
import HgfButton from "~/components/home/helmholtz/ui/HgfButton";

export function QualityReportDownloader() {
  const ctx = useSoftwareQualityOverviewContext()

  const [downloadActive, setDownloadActive] = useState(true)

  const [format, setFormat] = useState<DownloadFormat>('json');

  const handleFormatSelect = (event: SelectChangeEvent) => {
    setFormat(event.target.value as DownloadFormat)
  }

  const download = () => {
    ctx.downloadQualityReports(format)
  }

  useEffect(() => {
    const inactive = ctx.evaluatedSoftware.every((software) =>
      !software.current_evaluation_status.submitted || software.current_evaluation_status.evaluation_result !== 'counted'
    );

    setDownloadActive(!inactive)
  }, [ctx.evaluatedSoftware])

  return (
    <>
      <Grid container direction="column" spacing={2} justifyContent="end">
        <Stack direction="row" spacing={2}>
          <FormControl size="small">
            <InputLabel id="download-format-select-label">Format</InputLabel>
            <Select
              sx={{minWidth: "6rem"}}
              labelId="demo-format-select-label"
              id="demo-format-select"
              value={format}
              label="Format"
              onChange={handleFormatSelect}
            >
              <MenuItem value={'json'}>JSON</MenuItem>
              <MenuItem value={'csv'}>CSV</MenuItem>
            </Select>
          </FormControl>
          <HgfButton style='primary' size='small' disabled={!downloadActive} onClick={() => download()} >Download</HgfButton>
        </Stack>
        <QualityReportDownloadHistory />
      </Grid>
    </>
  )
}
